import React from 'react';
import PropTypes from 'prop-types';
import {
  Form,
  Modal,
  Button,
  Col,
  Input,
  Row,
  Select,
  Typography,
  Spin,
} from 'antd';

const { Text } = Typography;

const SocialEdit = ({
  isOpen,
  toggle,
  initialValues,
  onSubmit,
  linkTypeMenu,
  typeInputProps,
  linkInputProps,
  modalTitle,
  isLoading,
  isError,
  errorMsg,
  isSuccess,
  successMsg,
}) => (
  <Modal title={modalTitle} visible={isOpen} footer={null} onCancel={toggle}>
    {isLoading ? (
      <Spin size="large" />
    ) : (
      <Form
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 14 }}
        onFinish={onSubmit}
        initialValues={initialValues}
      >
        <Form.Item
          label={typeInputProps?.label}
          name={typeInputProps?.name}
          rules={typeInputProps?.rules}
        >
          <Select placeholder={typeInputProps?.placeholder}>
            {linkTypeMenu}
          </Select>
        </Form.Item>
        <Form.Item
          label={linkInputProps?.label}
          name={linkInputProps?.name}
          rules={linkInputProps?.rules}
        >
          <Input />
        </Form.Item>
        {isError ? <Text type="danger">{errorMsg}</Text> : null}
        {isSuccess ? <Text type="success">{successMsg}</Text> : null}
        <Row justify="end">
          <Col>
            <Button type="primary" htmlType="submit">
              Add
            </Button>
          </Col>
        </Row>
      </Form>
    )}
  </Modal>
);

export const inputPropTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  rules: PropTypes.arrayOf(
    PropTypes.shape({
      required: PropTypes.bool,
      message: PropTypes.string.isRequired,
    })
  ),
  placeholder: PropTypes.string,
};

SocialEdit.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  initialValues: PropTypes.object,
  onSubmit: PropTypes.func.isRequired,
  linkTypeMenu: PropTypes.array,
  modalTitle: PropTypes.string.isRequired,
  typeInputProps: PropTypes.shape(inputPropTypes),
  linkInputProps: PropTypes.shape(inputPropTypes),
  isLoading: PropTypes.bool,
  isError: PropTypes.bool,
  errorMsg: PropTypes.string,
  isSuccess: PropTypes.bool,
  successMsg: PropTypes.string,
};

export default SocialEdit;
